"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rulesReducer = void 0;
const lodash_1 = __importDefault(require("lodash"));
// Convert the Rules Data from the API to a flatter object that's easier to read and
// write to (less nested with edges/nodes)
const rulesDataToRulesObject = ({ rules }) => {
    return rules.edges.reduce((acc, { node: { id, enabled, name, variables } }) => {
        acc[name] = { id, enabled, variables };
        return acc;
    }, {});
};
function updateRule(rules, path, value) {
    return lodash_1.default.set(lodash_1.default.cloneDeep(rules), path, value);
}
function addExclusion(rules, path, exclusionDay) {
    const previousValue = lodash_1.default.get(rules, path) || [];
    return updateRule(rules, path, [...previousValue, exclusionDay]);
}
function removeExclusion(rules, path, exclusionDay) {
    const previousValue = lodash_1.default.get(rules, path) || [];
    return updateRule(rules, path, previousValue.filter((item) => item !== exclusionDay));
}
// eslint-disable-next-line complexity
function rulesReducer(rules, action) {
    switch (action.type) {
        case 'SET_RULES':
            return rulesDataToRulesObject(action.payload);
        case 'LAST_UPDATE_FULFILLMENT_ENABLED':
            return updateRule(rules, 'FulfillmentStalled.enabled', action.payload);
        case 'LAST_UPDATE_FULFILLMENT_INTERVAL': {
            return updateRule(rules, 'FulfillmentStalled.variables.firstScannedIntervalHours', parseInt(action.payload, 10));
        }
        case 'LAST_UPDATE_FULFILLMENT_ADD_EXCLUSION': {
            return addExclusion(rules, 'FulfillmentStalled.variables.excludedDaysOfWeek', action.payload);
        }
        case 'LAST_UPDATE_FULFILLMENT_REMOVE_EXCLUSION': {
            return removeExclusion(rules, 'FulfillmentStalled.variables.excludedDaysOfWeek', action.payload);
        }
        case 'LAST_UPDATE_TRANSIT_ENABLED':
            return updateRule(rules, 'ShipmentStalled.enabled', action.payload);
        case 'LAST_UPDATE_TRANSIT_INTERVAL': {
            return updateRule(rules, 'ShipmentStalled.variables.lastScannedIntervalHours', parseInt(action.payload, 10));
        }
        case 'LAST_UPDATE_TRANSIT_ADD_EXCLUSION': {
            return addExclusion(rules, 'ShipmentStalled.variables.excludedDaysOfWeek', action.payload);
        }
        case 'LAST_UPDATE_TRANSIT_REMOVE_EXCLUSION': {
            return removeExclusion(rules, 'ShipmentStalled.variables.excludedDaysOfWeek', action.payload);
        }
        case 'RETURN_TO_SENDER_ENABLED':
            return updateRule(rules, 'ShipmentReturnedToSender.enabled', action.payload);
        case 'DELIVERY_ATTEMPTED_ENABLED':
            return updateRule(rules, 'ShipmentDeliveryAttempted.enabled', action.payload);
        default:
            return rules;
    }
}
exports.rulesReducer = rulesReducer;
